export const fixedCyclicalBinaryIrmInfo = [
  {
    type: "function",
    name: "getFixedCyclicalBinaryIRMInfo",
    inputs: [],
    stateMutability: "pure",
    outputs: [
      {
        name: "fixedCyclicalBinaryIRMInfo",
        type: "tuple",
        internalType: "struct FixedCyclicalBinaryIRMInfo",
        components: [
          {
            name: "primaryRate",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "secondaryRate",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "primaryDuration",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "secondaryDuration",
            type: "uint256",
            internalType: "uint256",
          },
          {
            name: "startTimestamp",
            type: "uint256",
            internalType: "uint256",
          },
        ],
      },
    ],
  },
] as const
